import Vue from 'vue';
import Vuex from 'vuex';
// 模块
import common from './modules/common';
import user from './modules/user'

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    common, // 系统初始化
    user, // 个人信息
  }
});

export default store;



//////////////////
// WEBPACK FOOTER
// ./store/index.js
// module id = null
// module chunks = 